
/**
 * Functions for generating diary entry introductions
 */

export function generateIntroduction(babyName: string, mood: string): string {
  const moodIntroductions: Record<string, string[]> = {
    happy: [
      `${babyName} was full of smiles and giggles today!`,
      `Today was filled with joy as ${babyName} beamed with happiness throughout the day.`,
      `What a delightful day with ${babyName}! Their laughter was contagious.`,
      `${babyName} had the sunniest disposition today, bringing warmth to every moment.`,
      `The house was filled with ${babyName}'s cheerful energy today, making everything brighter.`,
      `${babyName}'s happy squeals and giggles were the soundtrack to our day.`
    ],
    calm: [
      `${babyName} had a peaceful and serene day today.`,
      `Today, ${babyName} was in such a calm and content mood.`,
      `It was a gentle day with ${babyName}, who seemed perfectly at ease with the world.`,
      `${babyName} carried a tranquil energy throughout the day, soaking everything in quietly.`,
      `There was a beautiful stillness about ${babyName} today, observing the world with quiet curiosity.`,
      `${babyName} seemed to find their center today, peaceful and present in each moment.`
    ],
    curious: [
      `${babyName}'s curiosity was in full bloom today as they explored their surroundings.`,
      `Today, ${babyName} was on a mission to discover everything within reach!`,
      `${babyName} was absolutely fascinated by everything today, their eyes wide with wonder.`,
      `I watched in amazement as ${babyName} investigated every new object with focused attention.`,
      `${babyName}'s inquisitive nature was on full display today, examining everything with careful interest.`,
      `Everything was worthy of investigation for ${babyName} today - from shadows on the wall to the texture of their toys.`
    ],
    fussy: [
      `${babyName} had a slightly unsettled day today, seeking extra comfort and reassurance.`,
      `Today was a bit challenging as ${babyName} seemed to need extra soothing and attention.`,
      `${babyName} had moments of fussiness today, but we made it through with plenty of cuddles.`,
      `It was one of those days where ${babyName} needed a little extra patience and comfort.`,
      `${babyName} seemed to have big feelings today that needed gentle acknowledgment and support.`,
      `We had a few bumpy moments with ${babyName} today, but found our rhythm with extra snuggles.`
    ],
    sleepy: [
      `${babyName} was especially drowsy today, taking longer naps than usual.`,
      `Today was filled with peaceful slumber for ${babyName}.`,
      `${babyName} spent much of the day in dreamland, waking only for feeds and brief play.`,
      `A day of deep rest for ${babyName}, who seemed to need the extra sleep today.`,
      `${babyName}'s eyelids were heavy today, drifting off to sleep more quickly than usual.`,
      `It was a sleepy, cozy day with ${babyName}, who seemed to be going through a growth spurt.`
    ]
  };
  
  const introductions = moodIntroductions[mood] || moodIntroductions.happy;
  return introductions[Math.floor(Math.random() * introductions.length)];
}

export function generateGreeting(formattedDate: string): string {
  const greetings = [
    `Today's Memories`,
    `Sweet moments today`,
    `Today's highlights`,
    `Precious moments`,
    `Special moments today`,
    `Capturing today`,
    `A day to remember`,
    `Today's journey`,
    `Moments to treasure`,
    `Today with ${formattedDate}`,
    `Beautiful moments today`,
    `Daily joy`,
    `Today's adventures`
  ];
  
  return greetings[Math.floor(Math.random() * greetings.length)];
}
